var en = {
  lorule: {
    general: {
      update: '更新',
      close: '閉じる'
    },
    forbidden: 'ページが見つかりませんでした。ご覧になる為に必要な許可がない可能性があります。',
    logIn: {
      notLoggedIn: 'ログインされていません。',
      title: 'ログイン',
      out: 'ログアウト'
    },
    userProfile: {
      title: 'ユーザープロフィール',
      edit: 'プロフィールを編集',
      name: '名前',
      username: 'ユーザー名',
      regionalOffice: '地域',
      preferredLanguage: '言語',
      timezone: 'タイムゾーン'
    }
  }
};
export default en;